Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.labelTitleText = "Geofence";
exports.labelBodyText = "Geofence Body";
exports.radarKey = "prj_live_pk_dc7bbaa26e61343e20a955965be95a7035dd611a";
// Customizable Area End